const getDocumentActiveElement = (element) => {
  try {
    const domNode = typeof element === "string" ? document.querySelector(element) : element;
    const root = domNode.getRootNode();
    return root.activeElement;
  } catch (e) {
    console.error("Feil ved å ta tak i active element basert på angitt node: ", element, e);
    return null;
  }
};
export {
  getDocumentActiveElement
};
//# sourceMappingURL=focus.js.map
